module.exports = __webpack_public_path__ + "static/media/program-5.6238116a.webp";